import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useVoip } from '../components/voip/hooks/use-voip';
import { VoipContext } from './voip-context';
export const VoipContextProvider = ({ children }) => {
    const { accessMicroStatus, activeCall, cancelCall, clearMicroStates, guiMuteAudio, haveDevices, loginStatus, muteAudio, phone, remoteAudioVideo, setAccessMicroStatus, setLoginStatus, setVoipScreen, startCall, timerText, voipScreen, isActiveTimer, } = useVoip();
    const context = useMemo(() => ({
        accessMicroStatus,
        activeCall,
        cancelCall,
        clearMicroStates,
        guiMuteAudio,
        haveDevices,
        loginStatus,
        muteAudio,
        phone,
        remoteAudioVideo,
        setAccessMicroStatus,
        setLoginStatus,
        setVoipScreen,
        startCall,
        timerText,
        voipScreen,
        isActiveTimer,
    }), [
        accessMicroStatus,
        activeCall,
        cancelCall,
        clearMicroStates,
        guiMuteAudio,
        haveDevices,
        isActiveTimer,
        loginStatus,
        muteAudio,
        phone,
        remoteAudioVideo,
        setAccessMicroStatus,
        setLoginStatus,
        setVoipScreen,
        startCall,
        timerText,
        voipScreen,
    ]);
    return _jsx(VoipContext.Provider, { value: context, children: children });
};
